// 点赞——主流程
const MainRoutes = Array.from({ length: 11 }, (_, i) => ({
  path: `icon/love/index${i + 1}`,
  name: `icon/loveIndex${i + 1}`,
  component: () => import(`@/views/recognize/icon/love/index${i + 1}.vue`)
}))



export default {
  path: '/recognize',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
    // 点赞——主流程，开始
    ...MainRoutes,
  ],
};
